module.exports = __webpack_public_path__ + "legal/KİŞİSEL VERİLERİ KORUMA KANUNU.becfd3f4.pdf";